interface EmptyStateProps {
  /** Headline ("No metros match your filters"). */
  readonly title: string;
  /** Optional supporting copy. */
  readonly description?: string;
  /** Optional action button — usually a "Clear filters" link or button. */
  readonly action?: React.ReactNode;
}

/**
 * Friendly placeholder for filtered lists with zero matches. Strives to give
 * the user a clear next action via the optional `action` slot.
 *
 * @example
 *   <EmptyState
 *     title="No metros match your filters"
 *     description="Try removing the status filter, or reset the search."
 *     action={<button onClick={resetFilters}>Clear filters</button>}
 *   />
 */
export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className="mx-auto max-w-md rounded-md border border-dashed border-border bg-surface p-10 text-center">
      <p className="mb-2 text-base font-semibold text-text-1">{title}</p>
      {description && <p className="mb-5 text-sm text-text-3">{description}</p>}
      {action}
    </div>
  );
}
